var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerK(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 64,
    viewBox: "0 0 32 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47949 0H0.979492V4H2.47949V0ZM2.47949 8H0.979492V12H2.47949V8ZM0.979492 16H2.47949V20H0.979492V16ZM0.979492 24H2.47949V28H0.979492V24ZM0.979492 48H2.47949V52H0.979492V48ZM2.47949 56H0.979492V60H2.47949V56ZM0.979492 32H2.47949V36H0.979492V32ZM0.979492 40H2.47949V44H0.979492V40ZM24.647 30.1398L21.2197 32.2024L21.9932 33.4876L25.4204 31.4251L24.647 30.1398ZM21.4512 57.0852L22.2863 55.8392L25.609 58.0661L24.7739 59.3121L21.4512 57.0852ZM15.6378 51.3958L14.8027 52.6418L18.1255 54.8688L18.9606 53.6227L15.6378 51.3958ZM4.08975 42.52L4.85976 43.81L4.57976 43.98L5.66975 44.71L4.82976 45.95L2.75977 44.57L2.79976 43.3L4.08975 42.52ZM28.9315 60.3312L28.0957 61.5768L30.6616 63.2984L31.4974 62.0528L28.9315 60.3312ZM7.51172 40.459L10.9389 38.3964L11.7124 39.6816L8.28517 41.7442L7.51172 40.459ZM17.7973 34.2705L14.3701 36.333L15.1436 37.6182L18.5708 35.5557L17.7973 34.2705ZM8.16113 48.1746L8.99623 46.9285L12.319 49.1554L11.4839 50.4015L8.16113 48.1746Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerK);
export default __webpack_public_path__ + "static/media/LOWER_K.ef850146ab83b0b299e4703d495f58b6.svg";
export { ForwardRef as ReactComponent };